import React from 'react';
import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';

const styles = theme => ({});

const AfitdBadge = props => {
    const { isHidden, children, ...otherProps } = props;

    return isHidden ? null : <Badge {...otherProps}>{children}</Badge>;
};

// export default AfitdBox;
export default withStyles(styles)(AfitdBadge);
